import {
  Component,
  EventEmitter,
  Input,
  Output,
  Pipe,
  PipeTransform,
  ViewChild
} from '@angular/core';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import { Project } from 'src/app/model/project/project';
import { SignPositionTypesChoices } from '../../../../../model/sign/enums/sign-position-type';
import { ClientSignSelectorComponent } from './client-sign-selector/client-sign-selector.component';
import BoardPart from '../../../../../model/product/board/board-part';
import { SignDetail } from '../../../../../model/sign/sign-detail';
import { IpBoardMeasurement } from './helper/IpBoardMeasurement';
import { SignHelper } from '../../../../../helpers/sign-helper';
import { ProjectDisplayObservableService } from '../../../../../services/project-display-observable.service';

@Component({
  selector: 'client-ip-board-form',
  templateUrl: './client-ip-board-form.component.html',
  styleUrls: [
    './client-ip-board-form.component.scss',
    './client-ip-board-shared-style.scss'
  ]
})
export class ClientIPBoardFormComponent {
  @Input()
  ipBoard: IPBoard;
  @Input()
  project: Project;
  @Input()
  oldSystemImmo: boolean = false;
  @Output()
  save = new EventEmitter<any>();

  @ViewChild('leftBoard') leftBoard: ClientSignSelectorComponent;
  @ViewChild('rightBoard') rightBoard: ClientSignSelectorComponent;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {}

  saveCustomBoardSettings() {
    this.setRightBoard();
    this.save.emit();
  }

  resetRightBoard() {
    this.projectDisplayObservableService
      .getResetLeftRightSubscribable()
      .next(this.ipBoard.leftRightBoard);
  }

  setRightBoard() {
    this.ipBoard.otherSideBoardPart = null;
    if (this.ipBoard.leftRightBoard) {
      this.ipBoard.otherSideBoardPart = new BoardPart();
      if (!!this.rightBoard) {
        this.rightBoard.resetSelectSign();
      }
      if (
        this.ipBoard.boardPart != null &&
        this.ipBoard.boardPart.sign != null &&
        this.ipBoard.boardPart.sign.position != null &&
        SignPositionTypesChoices.RIGHT.label ===
          this.ipBoard.boardPart.sign.position.label
      ) {
        this.leftBoard.resetSelectSign();
      }
    }
  }

  updateRightBoard() {
    this.setRightBoard();
    this.resetRightBoard();
    this.save.emit();
  }
}

@Pipe({
  name: 'ipBoardMeasurement',
  pure: true
})
export class IPBoardMeasurementPipe implements PipeTransform {
  transform(
    signDetail: SignDetail,
    otherHeight: number,
    otherWidth: number
  ): IpBoardMeasurement {
    if (signDetail != null) {
      return SignHelper.getActualSizes(signDetail);
    } else {
      return {
        height: otherHeight,
        width: otherWidth
      };
    }
  }
}
